import Mock from "mockjs";
import setupMock from "@/utils/setupMock";

const INTERFACES = ["getBySteam", "getByCdk", "steamInfo", "appTicket"];
const ERRORS = [
  "Steam 登录凭证失效",
  "账号窗口未开始",
  "上游服务超时",
  "CDK 已被使用",
];
const IPS = ["10.0.0.12", "10.0.0.31", "172.16.8.5", "203.0.113.7"];
const CREATORS = ["admin", "运营小李", "客服小王", "系统"];
const GAMES: Record<string, string> = {
  "1091500": "Cyberpunk 2077",
  "1245620": "Elden Ring",
  "1174180": "Red Dead Redemption 2",
};

let seq = 5000;
const records = Array.from({ length: 83 }).map((_, index) => {
  const success = Math.random() > 0.2 ? 1 : 0;
  const created = new Date(Date.now() - index * 1800 * 1000);
  return {
    id: seq++,
    interfaceName: INTERFACES[Math.floor(Math.random() * INTERFACES.length)],
    requestPath: "/drm/ticket",
    cdk: `CDK-${String(1000 + index).padStart(6, "0")}`,
    steamId: `76561198${String(100000000 + index).slice(-9)}`,
    gameId: String([1091500, 1245620, 1174180][index % 3]),
    gameName: GAMES[String([1091500, 1245620, 1174180][index % 3])],
    accountId: (index % 7) + 1,
    username: `steam_user_${String((index % 9) + 1).padStart(2, "0")}`,
    success,
    errorMessage: success
      ? ""
      : ERRORS[Math.floor(Math.random() * ERRORS.length)],
    eticket: success
      ? `ET-${Math.random().toString(36).slice(2, 10).toUpperCase()}`
      : "",
    appticket: success
      ? `AT-${Math.random().toString(36).slice(2, 10).toUpperCase()}`
      : "",
    eticketLength: success ? Math.floor(Math.random() * 500) + 100 : 0,
    appticketLength: success ? Math.floor(Math.random() * 200) + 50 : 0,
    clientIp: IPS[Math.floor(Math.random() * IPS.length)],
    createdBy: (index % 4) + 1,
    createdByName: CREATORS[index % CREATORS.length],
    durationMs: Math.floor(Math.random() * 1200) + 30,
    createdAt: created
      .toLocaleString("zh-CN", { hour12: false })
      .replace(/\//g, "-"),
  };
});

setupMock({
  setup: () => {
    Mock.mock(new RegExp("/ticket/log/list"), (options) => {
      const url = new URL(options.url, "http://mock.local");
      const page = Number(url.searchParams.get("page") || 1);
      const pageSize = Number(
        url.searchParams.get("limit") || url.searchParams.get("pageSize") || 10
      );
      const steamId = url.searchParams.get("steamId") || undefined;
      const gameId = url.searchParams.get("gameId") || undefined;
      const cdk = url.searchParams.get("cdk") || undefined;
      const success = url.searchParams.get("success");
      const startDate = url.searchParams.get("startDate") || undefined;
      const endDate = url.searchParams.get("endDate") || undefined;

      const filtered = records.filter((item) => {
        if (steamId && !(item.steamId || "").includes(steamId)) return false;
        if (gameId && item.gameId !== gameId) return false;
        if (cdk && !(item.cdk || "").toLowerCase().includes(cdk.toLowerCase()))
          return false;
        if (success !== null && Number(item.success) !== Number(success))
          return false;
        const day = (item.createdAt || "").slice(0, 10);
        if (startDate && day < startDate) return false;
        if (endDate && day > endDate) return false;
        return true;
      });

      const start = (page - 1) * pageSize;
      return {
        code: 200,
        data: {
          current: page,
          size: pageSize,
          total: filtered.length,
          records: filtered.slice(start, start + pageSize),
        },
        message: "ok",
      };
    });

    Mock.mock(new RegExp("/ticket/log/delete"), () => {
      return { code: 200, message: "删除成功" };
    });

    Mock.mock(new RegExp("/ticket/log/stats"), () => {
      const total = records.length;
      const success = records.filter(
        (item) => Number(item.success) === 1
      ).length;
      const today = new Date().toISOString().slice(0, 10);
      return {
        code: 200,
        data: {
          today: records.filter((item) =>
            (item.createdAt || "").startsWith(today)
          ).length,
          yesterday: 12,
          week: 47,
          month: 68,
          lastMonth: 120,
          total,
          success,
          fail: total - success,
        },
        message: "ok",
      };
    });
  },
});
